<div class="flex flex-column w-full text-left">
	<form [formGroup]="formGroup" class="flex flex-column gap-3">
		<!-- Contenedor del formulario -->
		<div class="flex flex-column align-items-stretch align-self-stretch gap-3">
			<label class="context-label text-center w-full">
				{{ translations['createAccountToGetStarted'] || 'Create account to get started' }}
			</label>

			<!-- Argentina Cuit -->
			<div *ngIf="isArgentina" class="flex flex-row w-full gap-3">
				<div class="w-full flex flex-column gap-2">
					<label class="field-label font-semibold text-black">{{ translations['identityCard'] || 'Identity Card' }}*</label>
						<!-- [options]="identificationTypeEnums" -->
					<app-input
						type="dropdown"
						formControlName="identityCardType"
					/>
				</div>
				<div class="w-full flex flex-column gap-2">
					<label class="field-label font-semibold text-black">{{ translations['identityCard'] || 'Identity Card' }}*</label>
					<app-input
						type="text"
						[placeholder]="translations['identityCard'] || 'Identity Card'"
						formControlName="identityCard"
						required
					/>
					<span class="error-message block mt-1" *ngIf="isFieldInvalid('identityCard')">
						{{ getFieldErrorMessage("identityCard") }}
					</span>
				</div>
			</div>

			<!-- Row 1: Name and Last Name -->
			<div class="flex flex-row w-full gap-3">
				<div class="w-full flex flex-column gap-2">
					<label class="field-label font-semibold text-black" for="name">{{ translations['name'] || 'Name' }}*</label>
					<app-input
						type="text"
						id="name"
					[placeholder]="translations['name'] || 'Name'"
						formControlName="name"
						required
					/>
					<span class="error-message block mt-1" *ngIf="isFieldInvalid('name')">
						{{ getFieldErrorMessage("name") }}
					</span>
				</div>
				<div class="w-full flex flex-column gap-2">
					<label class="field-label font-semibold text-black" for="lastName">{{ translations['lastName'] || 'Last Name' }}*</label>
					<app-input
						type="text"
						id="lastName"
					[placeholder]="translations['lastName'] || 'Last Name'"
						formControlName="lastName"
						required
					/>
					<span class="error-message block mt-1" *ngIf="isFieldInvalid('lastName')">
						{{ getFieldErrorMessage("lastName") }}
					</span>
				</div>
			</div>

			<!-- Row 2: Phone and Email -->
			<div class="flex flex-row w-full gap-3">
				<div class="w-full flex flex-column gap-2">
					<label class="field-label font-semibold text-black" for="phone">{{ translations['phone'] || 'Phone' }}*</label>
					<app-input
						type="text"
						id="phone"
					[placeholder]="translations['phone'] || 'Phone'"
						formControlName="phone"
						required
						maxlength="14"
						(input)="formatPhone($event)"
					/>
					<span class="error-message block mt-1" *ngIf="isFieldInvalid('phone')">
						{{ getFieldErrorMessage("phone") }}
					</span>
				</div>
				<div class="w-full flex flex-column gap-2">
					<label class="field-label font-semibold text-black" for="email">{{ translations['email'] || 'Email' }}*</label>
					<app-input
						type="email"
						id="email"
					[placeholder]="translations['email'] || 'Email'"
						formControlName="email"
						required
					/>
					<span class="error-message block mt-1" *ngIf="isFieldInvalid('email')">
						{{ getFieldErrorMessage("email") }}
					</span>
				</div>
			</div>

			<!-- Row 3: Password and Confirm Password -->
			<div class="flex flex-row w-full gap-3">
				<div class="w-full flex flex-column gap-2">
					<label class="field-label font-semibold text-black" for="password">{{ translations['password'] || 'Password' }}*</label>
					<app-input
						type="password"
						id="password"
					[placeholder]="translations['password'] || 'Password'"
						formControlName="password"
						required
					/>
					<span class="error-message block mt-1" *ngIf="isFieldInvalid('password')">
						<ul class="pl-3 my-1">
							<li class="text-left" *ngFor="let msg of getFieldErrorMessages('password')">
								<span class="text-left">{{ msg }}</span>
							</li>
						</ul>
					</span>
				</div>
				<div class="w-full flex flex-column gap-2">
					<label class="field-label font-semibold text-black" for="confirmPassword">{{ translations['confirmPassword'] || 'Confirm Password' }}*</label>
					<app-input
						type="password"
						id="confirmPassword"
					[placeholder]="translations['confirmPassword'] || 'Confirm Password'"
						formControlName="confirmPassword"
						required
					/>
					<div class="flex align-items-center gap-1 w-full mt-1" *ngIf="formGroup.get('confirmPassword')?.dirty && formGroup.errors?.['passwordMismatch']">
						<span class="error-message block mt-1 flex align-items-center gap-1 mt-0">
							<app-icon iconName="alert-circle" class="text-lg"></app-icon>
							{{ translations['passwordsDoNotMatch'] || 'Passwords do not match' }}
						</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Checkbox de terms and conditions-->
		<div class="custom-checkbox flex align-items-center justify-content-start w-full gap-2 mt-2">
			<app-input type="checkbox" id="termsAccepted" formControlName="termsAccepted" required />
			<label for="termsAccepted" class="input-legend">
				{{ translations['iAgreeToThe'] || 'I agree to the' }}
				<a href="javascript:void(0)" (click)="openTermsModal()" class="text-black cursor-pointer font-bold">
					{{ translations['termsAndConditions'] || 'Terms and conditions' }}
				</a>
			</label>
		</div>

		<!-- Button de creación de cuenta -->
		<div class="flex flex-column align-items-center w-full align-self-stretch">
			<app-button
				class="w-full block"
				[text]="translations['createAccount'] || 'Create Account'"
				[type]="getButtonType(!formGroup.get('termsAccepted')?.value || (loading$ | async) || !!(loadingStore$ | async) || formGroup.invalid)"
				[disabled]="!formGroup.get('termsAccepted')?.value || (loading$ | async) || !!(loadingStore$ | async) || formGroup.invalid"
				(buttonClicked)="onSignUp()"
			/>
		</div>

		<!-- Already have an account -->
		<div class="text-center mt-3">
			<p class="register-text text-center font-normal line-height-2">
				{{ translations['alreadyHaveAccount'] || 'Already have an account?' }} 
				<a class="text-black cursor-pointer font-bold" (click)="navigateTo(AuthModalComponentEnum.LOGIN)">
					{{ translations['logIn'] || 'Log In' }}
				</a>
			</p>
		</div>
	</form>
</div>
